import { useState } from "react"
import "bootstrap/dist/css/bootstrap.min.css"
import { Form, Button } from "react-bootstrap"
import { useNavigate } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { twoFactorAuth } from "../../data/authenticationSlice"
import { css } from "@emotion/react"
import Loader from "../../components/Loader"

const componentStyles = css`
    .no-spinners::-webkit-inner-spin-button,
    .no-spinners::-webkit-outer-spin-button {
        -webkit-appearance: none !important;
        margin: 0;
    }

    .no-spinners {
        -moz-appearance: textfield !important;
    }
`

const LoginMFA = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const [formData, setFormData] = useState({
        verificationCode: "",
        rememberMe: false
    })
    const [errors, setErrors] = useState({ verificationCode: null })
    const { fetchStatus } = useSelector((state) => state.authentication)

    const handleChange = (event) => {
        const { name, value, checked, type } = event.target

        setFormData({
            ...formData,
            [name]: type === "checkbox" ? checked : value
        })
    }

    const handleSubmit = async (event) => {
        event.preventDefault()

        const { verificationCode, rememberMe } = formData
        const site = location.pathname.split("/")[1]

        if (!verificationCode || !/^[0-9]{6}$/.test(verificationCode)) {
            setErrors({
                verificationCode:
                    !verificationCode || !/^[0-9]{6}$/.test(verificationCode)
                        ? "Please enter a valid verification code"
                        : ""
            })
            return false
        }
        let payload = {
            twoFactorCode: verificationCode,
            rememberMe,
            returnUrl: ""
        }
        dispatch(twoFactorAuth(payload)).then(({ payload }) => {
            if (payload?.succeeded) {
                window.sessionStorage.removeItem("ACCESS_TOKEN") //Removing the old LogIn token
                window.sessionStorage.setItem("ACCESS_TOKEN", payload?.token) //Setting the new 2FA token
                if (payload?.refreshToken) {
                    window.sessionStorage.removeItem("REFRESH_TOKEN")
                    window.sessionStorage.setItem("REFRESH_TOKEN", payload?.refreshToken)
                }
                site === "admin" ? navigate(`/${site}/applications`) : navigate(`/${site}/dashboard`)
            } else {
                setErrors({
                    verificationCode: "Invalid verification code."
                })
            }
        })
    }

    return (
        <div
            css={componentStyles}
            className=" container d-flex justify-content-center align-items-center vh-100">
            <Loader show={fetchStatus === "loading"} />
            <div className="bg-white col-md-5 auth-box py-5">
                <h1 className="text-center mb-4">Enter Verification Code</h1>
                <Form onSubmit={handleSubmit}>
                    <Form.Group>
                        <Form.Label>Six digit code</Form.Label>
                        <Form.Control
                            type="number"
                            className="form-control-sm no-spinners"
                            name="verificationCode"
                            value={formData.verificationCode}
                            onChange={handleChange}
                            placeholder="Enter six digit code"
                        />
                        {errors?.verificationCode && (
                            <Form.Text className="text-danger">{errors?.verificationCode}</Form.Text>
                        )}
                    </Form.Group>
                    <Form.Group
                        controlId="rememberMeForm"
                        className="mt-2">
                        <Form.Check
                            type="checkbox"
                            id="rememberMe"
                            name="rememberMe"
                            label="Remember this device for 30 days"
                            checked={formData.rememberMe === true}
                            onChange={handleChange}
                        />
                    </Form.Group>
                    <div className="d-grid mt-2">
                        <Button
                            className="btn-sm"
                            type="submit"
                            variant="primary">
                            Submit
                        </Button>
                    </div>
                </Form>
            </div>
        </div>
    )
}

export default LoginMFA
